import useMessageRelay from "../../../../external/internal/useMessageRelay";
import { useCallback, useMemo } from "react";
import { cleanAndEmitMosaicEvent } from "../../../../external/internal/events";
import useNav from "../connectors/nav/useNav";
import useMosaicEvent from "../connectors/events/useMosaicEvent";
import ViewerEvent from "../api/core/ViewerEvent";
import {
  getBookInfo,
  getBookInfoStatus,
} from "../api/features/bookinfo/selectors";
import useReaderReduxGetter from "../api/core/useReaderReduxGetter";
import {
  getPageBreaks,
  getPageBreaksLoadStatus,
} from "../api/features/pagebreaks/selectors";
import {
  getHighlightsLoadStatus,
  getReconstructedHighlightsResponse,
} from "../api/features/highlights/selectors";
import useHighlights from "../connectors/highlights/useHighlights";

export default function useExternalReaderAPI() {
  const { goToPage, goToCFI } = useNav();
  const { deleteHighlight, updateHighlight } = useHighlights();

  useMosaicEvent(
    ViewerEvent.BOOK_PAGEBREAK,
    useCallback((detail) => {
      cleanAndEmitMosaicEvent(detail);
    }, [])
  );

  const getInfo = useReaderReduxGetter(getBookInfo, getBookInfoStatus);
  const getBreaks = useReaderReduxGetter(
    getPageBreaks,
    getPageBreaksLoadStatus
  );
  const getHighlights = useReaderReduxGetter(
    getReconstructedHighlightsResponse,
    getHighlightsLoadStatus
  );

  const methods = useMemo(
    () => ({
      goToPage,
      goToCFI,
      getBookInfo: getInfo,
      getPageBreaks: getBreaks,
      getHighlights,
      deleteHighlight,
      updateHighlight,
    }),
    [
      goToPage,
      goToCFI,
      getInfo,
      getBreaks,
      getHighlights,
      deleteHighlight,
      updateHighlight,
    ]
  );

  useMessageRelay("Reader", methods);
}
